import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 18px;
  align-items: start;
  cursor: pointer;
  margin: 6px 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const ContentSortAndFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  margin-bottom: 10px;
`;

export const ElParams = styled.div<{
  isShowTitleParams?: boolean;
  isSingle?: boolean;
}>`
  display: block;
  width: ${(props) =>
    props.isShowTitleParams ? "30%" : props.isSingle ? "4%" : "12%"};
  height: ${(props) => (props.isShowTitleParams ? "60px" : "22px")};
  overflow: hidden;
  transition: all 0.3s ease-in-out;

  span {
    display: block;
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
    margin-top: 10px;
    opacity: ${(props) => (props.isShowTitleParams ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
  }
`;

export const Title = styled.span`
  font-size: 15px;
  font-weight: 600;
  line-height: 19px;
  color: #ffffff;
`;

export const OtherFiltersContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 14px;
  margin-left: auto;
`;

export const ImageWrapper = styled.div<{disabled?: boolean}>`
  min-width: 44px;
  max-width: 44px;
  height: 44px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  /* opacity: ${(props) => (props.disabled ? 0.5 : 1)}; */
  opacity: 1;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: opacity 0.3s ease;
`;

export const OtherFiltersImageWrapper = styled.a<{disabled?: boolean}>`
  width: 16px;
  height: 16px;
  display: block;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: opacity 0.3s ease;
`;

export const IconWrapper = styled.div<{disabled?: boolean}>`
  width: 16px;
  height: 16px;
  /* cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")}; */
  /* opacity: ${(props) => (props.disabled ? 0.5 : 1)}; */
  opacity: 1;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  transition: opacity 0.3s ease;

  img {
    width: 100%;
    height: 100%;
  }

  &:hover div {
    opacity: 1;
    visibility: visible;
  }
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  bottom: 120%; /* Расположить тултип над иконкой */
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 8px;
  background-color: #333;
  color: #fff;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease;
  z-index: 10;
`;
